const PREF_KEY = "blh-unit-preferences";

const defaultPrefs = {
  heightUnit: "cm",
  weightUnit: "kg",
};

export function getUnitPrefs() {
  if (typeof window === "undefined") return {...defaultPrefs};
  try {
    const raw = window.localStorage.getItem(PREF_KEY);
    if (!raw) return {...defaultPrefs};
    const parsed = JSON.parse(raw);
    return {...defaultPrefs, ...parsed};
  } catch {
    return {...defaultPrefs};
  }
}

export function setUnitPrefs(prefs) {
  if (typeof window === "undefined") return;
  try {
    const next = {...defaultPrefs, ...prefs};
    window.localStorage.setItem(PREF_KEY, JSON.stringify(next));
  } catch {
    // ignore storage errors
  }
}

export const cmFromFeetIn = (feet, inches) => {
  const f = Number(feet) || 0;
  const i = Number(inches) || 0;
  return +(f * 30.48 + i * 2.54).toFixed(2);
};

export const feetInFromCm = (cm) => {
  const totalIn = (Number(cm) || 0) / 2.54;
  const feet = Math.floor(totalIn / 12);
  const inches = +(totalIn - feet * 12).toFixed(1);
  return {feet, inches};
};

export const kgFromLbs = (lbs) => {
  return +((Number(lbs) || 0) * 0.45359237).toFixed(2);
};

export const lbsFromKg = (kg) => {
  return +((Number(kg) || 0) / 0.45359237).toFixed(2);
};

export const formatHeight = (cm, unit = "cm") => {
  const value = Number(cm);
  if (!value) return "";
  if (unit === "ft-in") {
    const {feet, inches} = feetInFromCm(value);
    return `${feet} ft ${inches} in`;
  }
  return `${value} cm`;
};

export const formatWeight = (kg, unit = "kg") => {
  const value = Number(kg);
  if (!value) return "";
  if (unit === "lbs") return `${lbsFromKg(value)} lbs`;
  return `${value} kg`;
};

